import isArray from "lodash/isArray";

export const getTnvedVAT = (tnvedInfo?: TnvedInfo) => {
  if (!tnvedInfo) {
    return undefined;
  }

  const rawVat = tnvedInfo.GoodInfo?.VATlist?.VAT;
  if (!rawVat) {
    return undefined;
  }

  const vatArray = isArray(rawVat) ? rawVat : [ rawVat ];

  const vat = vatArray.map(v => ({
    ...v,
    Directory: {
      ...(v.Directory || {}),
      RuName: v.Directory?.RuName || tnvedInfo.GoodInfo?.Name || ''
    }
  }));

  return vat;
};

